const prependAsterisks = (value)=>{
    return '**********' + value;
};

export { prependAsterisks };
//# sourceMappingURL=prependAsterisks.mjs.map
